<template>
  <div class="wrap">
    <img src="../assets/images/404.png"/>
  </div>
</template>

<script>
  export default {
    name: 'no-found'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue